import { ALARM_STATUS } from "../../common/constant/common-constants";
import { getAlarmPriority } from "../../common/utils/CommonUtils";
import { Types } from "../actions/actionTypes";
import initialState from "../store/initial-state";
import { DEVICE_TYPES } from "../../common/constant/common-constants";

export const alarmDataReducer = (state = initialState.alarmDataReducer, action) => {

    switch (action.type) {
        case Types.NOCCARC_PM_ALARM_DATA: {

            // console.log("NOCCARC_PM_ALARM_DATA-------------------_>" , action.payload)
            let bedId = action.payload.bedId;

            let newAlarms = action.payload.activeAlarms || [];

            if (!bedId || !newAlarms)
                return;

            let newAlarms_physiological = newAlarms.filter(alarm => alarm.type === "PHYSIOLOGICAL") || [];
            let newAlarms_technical = newAlarms.filter(alarm => alarm.type === "TECHNICAL") || [];


            newAlarms_physiological.sort(function (alarm1, alarm2) {
                let alarm1Priority = getAlarmPriority(alarm1.priority.toUpperCase());
                let alarm2Priority = getAlarmPriority(alarm2.priority.toUpperCase());
                return alarm2Priority - alarm1Priority;
            });

            newAlarms_technical.sort(function (alarm1, alarm2) {
                let alarm1Priority = getAlarmPriority(alarm1.priority.toUpperCase());
                let alarm2Priority = getAlarmPriority(alarm2.priority.toUpperCase());
                return alarm2Priority - alarm1Priority;
            });



            let alarmData = state.alarmData;
            alarmData[bedId] = {
                ...alarmData[bedId],
                bedId: bedId,
                PM_alarms: {
                    alarms_physiological: [...newAlarms_physiological],
                    alarms__technical: [...newAlarms_technical]
                }

            }

            // console.log(alarmData)
            return {
                ...state,
                alarmData: { ...alarmData }
            }


        }

        case Types.VENTILATOR_ALARM_DATA: {
            // console.log("VENTILATOR_ALARM_DATA reducer payload----------->", action.payload)

            let bedId = action.payload.bedId;
            let newAlarms = action.payload.alarms || [];

            if (!bedId || !newAlarms) return state;
            let alarmData = state.alarmData;

            //Check Source of data
            // If the source is API, only update if existing data is null/undefined
            let source = action?.payload?.source;
            if (source === "API") {
                // console.log("BED-ID" , bedId)
                // console.log("Data in VENTILATOR_ALARM_DATA reducer statec----------->", alarmData?.[bedId]?.ventilatorAlarms)
                if (alarmData?.[bedId]?.ventilatorAlarms) {
                    return state
                }
            }

            newAlarms.sort(function (alarm1, alarm2) {
                let alarm1Priority = getAlarmPriority(alarm1.priority);
                let alarm2Priority = getAlarmPriority(alarm2.priority);
                return alarm1.isNotification || alarm2Priority - alarm1Priority;
            });
            alarmData[bedId] = {
                ...alarmData[bedId],
                bedId: bedId,
                ventilatorAlarms: [...newAlarms]
            }
            return {
                ...state,
                alarmData: { ...alarmData }
            }
        }

        case Types.CLEAR_BED_ALARM:
            let bedId = action.payload.bedId;
            let deviceId = action.payload.deviceId || "";
            let dongleId = action.payload.dongleId || "";
            let deviceType = action.payload.deviceType;
            if (!bedId) return;

            // let bedAlarmData = state.alarmData && state.alarmData[bedId] && state.alarmData[bedId].alarms;
            // if (bedId === 19)
            //     console.log("before action", bedAlarmData);

            // // bedAlarmData = [];
            let alarmData = state.alarmData;
            // if (bedId === 19)
            //     console.log("before action", alarmData);
            // if (bedId === 19)
            //     console.log("after action", alarmData);
            return {
                ...state,
                alarmData: {
                    ...state.alarmData,
                    [bedId]: {
                        ...state.alarmData[bedId],
                        alarms: []
                    }
                }
            }
        case Types.CLEAR_ALARM:
            return {
                ...state,
                alarmData: {}
            }
        default:
            return state;
    }
}